import { useApi, useApiIdError } from '@omnipresentgroup/api';
import type { GetSalaryHistoryAPIResponse } from '@omnipresentgroup/types';
import { useQuery } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';

type Selector<T> = (data: GetSalaryHistoryAPIResponse) => T;

type QueryParameters = {
  pageSize?: number | undefined;
  nextPageKey?: string | undefined;
};

export const useGetSalaryHistory = <T = GetSalaryHistoryAPIResponse>({
  companyId,
  enabled,
  select,
  params,
  throwOnError = true,
}: {
  companyId: string;
  enabled?: boolean;
  select?: Selector<T>;
  params?: QueryParameters;
  throwOnError?: boolean;
}) => {
  const { GET } = useApi();
  const error = useApiIdError(API_PATH);
  const query = useQuery({
    queryKey: [API_PATH, companyId, JSON.stringify(params)],
    queryFn: companyId
      ? () =>
          GET<GetSalaryHistoryAPIResponse>(
            `${API_BASE}/${API_PATH}/company/${companyId}`,
            {
              params,
            },
          )
      : () => Promise.reject(error),
    enabled,
    select,
    throwOnError,
  });

  return query;
};
